<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Xem chi tiết quản lý thu chi đã gửi lên</strong>
                    </div>
                    <div class="document-view" v-if="accounting.id">
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Đơn vị tạo:"
                                              label-for="input-unit"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input :value="accounting.unitName" :title="accounting.unitName" :readonly="true"></b-form-input>
                                </b-form-group>
                                <b-form-group label="QĐ phê duyệt PAXL: "
                                              label-for="unit"
                                              class="text-1"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <!--<template v-if="accounting.planNames.split(',').length > 1">-->
                                    <div style="padding: 10px">
                                        <ul style="display: inline; padding: 0">
                                            <li v-for="(plan, index) in accounting.planNames.split(',')"><router-link :to="`../handling-decision-results/${accounting.planIds.split('-')[index]}`">{{ plan }}</router-link></li>
                                        </ul>
                                    </div>
                                    <!--</template>
                                    <template v-else>
                                        <b-form-input :value="accounting.planNames" :title="accounting.planNames" :readonly="true"></b-form-input>
                                    </template>-->
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Tổng số tiền phải thu:"
                                              label-for="address"
                                              class="text-1"
                                              :label-cols="4"
                                              label-align="left"
                                              :horizontal="true">
                                    <b-form-input :value="accounting.valueEstimated | currency" :title="accounting.valueEstimated | currency" :readonly="true"></b-form-input>
                                </b-form-group>
                                <b-form-group label="Tổng số tiền đã thu:"
                                              label-for="address"
                                              class="text-1"
                                              :label-cols="4"
                                              label-align="left"
                                              :horizontal="true">
                                    <b-form-input :value="accounting.valueObtained | currency" :title="accounting.valueObtained | currency" :readonly="true"></b-form-input>
                                </b-form-group>
                                <b-form-group label="Tổng số còn phải thu:"
                                              label-for="address"
                                              class="text-1"
                                              :label-cols="4"
                                              label-align="left"
                                              :horizontal="true">
                                    <b-form-input :value="accounting.valueRemaining | currency" :title="accounting.valueRemaining | currency" :readonly="true"></b-form-input>
                                </b-form-group>
                                <b-form-group label="Tổng chi phí:"
                                              label-for="address"
                                              class="text-1"
                                              :label-cols="4"
                                              label-align="left"
                                              :horizontal="true">
                                    <b-form-input :value="accounting.handlingCost | currency" :title="accounting.handlingCost | currency" :readonly="true"></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </div>
                    <b-grid :gridOptions="gridOptions"
                            :items="accounting.details"
                            :showActions="false"
                            gridName="Thông tin thu chi">
                        <template v-slot:cell(custodyDate)="row">
                            {{ row.value | formatDate }}
                        </template>
                        <template v-slot:cell(obtainedDate)="row">
                            {{ row.value | formatDate }}
                        </template>
                        <template v-slot:cell(valueEstimated)="row">
                            {{ row.value | currency }}
                        </template>
                        <template v-slot:cell(valueObtained)="row">
                            {{ row.value | currency }}
                        </template>
                        <template v-slot:cell(valueRemaining)="row">
                            {{ row.value | currency }}
                        </template>
                        <template v-slot:cell(valueInCustody)="row">
                            {{ row.value | currency }}
                        </template>
                        <template v-slot:cell(handlingCost)="row">
                            {{ row.value | currency }}
                        </template>
                    </b-grid>
                    <b-row class="justify-content-center">
                        <b-button type="button" variant="secondary" :to="{ path: '.' }">Quay lại</b-button>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mixins } from '@/shared/mixins'

    export default {
        name: 'NationalPublicAssetDecisionHandlingAccountingDetail',
        mixins: [mixins],
        data() {
            return {
                accounting: {},
                gridOptions: {
                    fields: [
                        { key: 'valueEstimated', label: 'Số tiền phải thu', sortable: false, sortDirection: 'asc', tdClass: 'text-right' },
                        { key: 'valueObtained', label: 'Số tiền đã thu', sortable: false, sortDirection: 'asc', tdClass: 'text-right' },
                        { key: 'obtainedDate', label: 'Ngày thu', sortable: false, sortDirection: 'asc' },
                        { key: 'valueRemaining', label: 'Số tiền còn phải thu', sortable: false, sortDirection: 'asc', tdClass: 'text-right' },
                        { key: 'handlingCost', label: 'Chi phí', sortable: false, sortDirection: 'asc', tdClass: 'text-right' },
                        { key: 'valueInCustory', label: 'Số tiền nộp TKTG', sortable: false, sortDirection: 'asc', tdClass: 'text-right' },
                        { key: 'custodyDate', label: 'Ngày nộp', sortable: false, sortDirection: 'asc' },
                    ],
                    sortBy: 'id',
                    sortDirection: 'desc'
                },
            }
        },
        computed: {
            accountingId() {
                return this.$route.params.accountingId;
            }
        },
        created() {
            this.loadDecisionAccountingDetail();
        },
        methods: {
            loadDecisionAccountingDetail() {
                var vm = this;
                return this.$services.get(`data/handling-decisions-accounting-detail/${this.accountingId}`).done(data => {
                    vm.accounting = data;
                });
            }
        },
        watch: {
        }
    }
</script>
<style scoped>
    ul {
        columns: 2;
        -webkit-columns: 2;
        -moz-columns: 2;
    }
</style>
